import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "account__tab tab--3 is-open" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-xl-6" }
const _hoisted_4 = { class: "row form__field" }
const _hoisted_5 = ["type", "readonly"]
const _hoisted_6 = { class: "form__label required" }
const _hoisted_7 = { class: "row form__field" }
const _hoisted_8 = ["type", "readonly"]
const _hoisted_9 = { class: "form__label required" }
const _hoisted_10 = ["type", "readonly"]
const _hoisted_11 = { class: "form__label required" }
const _hoisted_12 = { class: "row form__field" }
const _hoisted_13 = { class: "col form__col btn__col" }
const _hoisted_14 = {
  class: "button",
  type: "submit",
  tabindex: "4"
}
const _hoisted_15 = {
  key: 0,
  style: {"margin-left":"10px","margin-top":"1px","position":"absolute"},
  class: "p-button-loading-icon pi pi-spinner pi-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "account__form",
      onSubmit: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.form.onSubmit && _ctx.form.onSubmit(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["col form__col", {
                                'form__group--active':
                                    _ctx.oldPasswordFocused || _ctx.form.values.old_password,
                            }])
            }, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form__input", { '--error': _ctx.form.errors.old_password }]),
                type: _ctx.inputType,
                tabindex: "1",
                autocomplete: "off",
                readonly: !_ctx.oldPasswordFocused,
                onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.oldPasswordFocused = true)),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.oldPasswordFocused = false)),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.values.old_password) = $event))
              }, null, 42, _hoisted_5), [
                [_vModelDynamic, _ctx.form.values.old_password]
              ]),
              _createElementVNode("label", _hoisted_6, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.loginInfoTab.oldPassword" })
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-sm-6 form__col", {
                                'form__group--active':
                                    _ctx.newPasswordFocused || _ctx.form.values.new_password,
                            }])
            }, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form__input", { '--error': _ctx.form.errors.new_password }]),
                type: _ctx.inputType,
                tabindex: "2",
                autocomplete: "off",
                readonly: !_ctx.newPasswordFocused,
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.newPasswordFocused = true)),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.newPasswordFocused = false)),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.values.new_password) = $event))
              }, null, 42, _hoisted_8), [
                [_vModelDynamic, _ctx.form.values.new_password]
              ]),
              _createElementVNode("label", _hoisted_9, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.loginInfoTab.newPassword" })
              ]),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPassword())),
                class: "form__pass",
                type: "button"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass({
                                        'bg-eye': _ctx.inputType === 'password',
                                        'bg-eye__on': _ctx.inputType === 'text',
                                    })
                }, null, 2)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["col-sm-6 form__col", {
                                'form__group--active':
                                    _ctx.repeatedPasswordFocused ||
                                    _ctx.form.values.new_password_repeated,
                            }])
            }, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form__input", { '--error': _ctx.form.errors.new_password_repeated }]),
                type: _ctx.inputType,
                tabindex: "3",
                onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.repeatedPasswordFocused = true)),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.repeatedPasswordFocused = false)),
                autocomplete: "off",
                readonly: !_ctx.repeatedPasswordFocused,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.values.new_password_repeated) = $event))
              }, null, 42, _hoisted_10), [
                [_vModelDynamic, _ctx.form.values.new_password_repeated]
              ]),
              _createElementVNode("label", _hoisted_11, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.loginInfoTab.repeatPassword" })
              ]),
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showPassword())),
                class: "form__pass",
                type: "button"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass({
                                        'bg-eye': _ctx.inputType === 'password',
                                        'bg-eye__on': _ctx.inputType === 'text',
                                    })
                }, null, 2)
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", _hoisted_14, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.saveBtn" }),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ], 32)
  ]))
}